import { z } from 'zod/v4';

export const fleetCloudProviderSchema = z.preprocess(
  (value) =>
    value !== null &&
    typeof value !== 'undefined' &&
    typeof value === 'string' &&
    /^MicrosoftAzure$/i.test(value)
      ? 'Azure'
      : 'AWS',
  z.union([z.literal('AWS'), z.literal('Azure')])
);

export type FleetCloudProvider = z.infer<typeof fleetCloudProviderSchema>;
